import React from "react";

const Modal = ({ children, onClose, maxWidth = "6xl" }) => {
    const maxWidthClasses = {
        "sm": "max-w-sm",
        "md": "max-w-md",
        "lg": "max-w-lg",
        "xl": "max-w-xl",
        "2xl": "max-w-2xl",
        "3xl": "max-w-3xl",
        "4xl": "max-w-4xl",
        "5xl": "max-w-5xl",
        "6xl": "max-w-6xl",
        "7xl": "max-w-7xl",
    };

    return (
        <div 
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50 p-4 backdrop-blur-sm"
            onClick={onClose}
        >
            <div 
                className={`dark-card ${maxWidthClasses[maxWidth] || maxWidthClasses["6xl"]} w-full max-h-[95vh] overflow-hidden relative animate-fade-in-up`}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    className="absolute top-4 right-4 z-50 w-10 h-10 flex items-center justify-center text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-all duration-200 transform hover:scale-110"
                    onClick={onClose}
                    title="Закрыть"
                >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
                <div className="overflow-y-auto max-h-[95vh] custom-scrollbar">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Modal;